class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  updateCartObject() {
    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        console.log("cart response");
        window.Cart = response;
      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // if (document.documentElement.scrollTop) {
    //   var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop
    //   scrollTop = `-${scrollTop}px`
    //   document.documentElement.classList.add('noscroll')
    //   document.documentElement.style.top = scrollTop
    // }

    // const b = document.querySelector('html');
    // b.style.setProperty('--st', -(document.documentElement.scrollTop) + "px");
    // b.classList.add('noscroll');

    document.body.classList.add("noscroll");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);

    // document.documentElement.classList.remove('noscroll');
    // var scrollTop = document.documentElement.style.top
    // scrollTop = scrollTop.replace('-','').replace('px', '')
    // document.documentElement.scrollTop = scrollTop
    document.body.classList.remove("noscroll");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove("is-empty");
    this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      console.log("section");
      console.log(section);
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class CartItemComponents extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector(".bundle-toggle");
    this.bundleItems = this.querySelector(".bundle-items");
    this.size = this.dataset.size;

    if (this.toggleButton && this.bundleItems) {
      this.toggleButton.addEventListener("click", () => this.toggleItems());
    }
  }

  toggleItems() {
    const isExpanded =
      this.toggleButton.getAttribute("aria-expanded") === "true";
    const itemCount = this.bundleItems.children.length;

    this.toggleButton.setAttribute("aria-expanded", !isExpanded);
    this.bundleItems.hidden = isExpanded;

    // Update button text
    this.toggleButton.innerHTML = `
      ${isExpanded ? "Show" : "Hide"} ${this.size} items 
      <div style="width: 8px;">
        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
        </svg>
      </div>

      `;
  }
}

customElements.define("cart-item-components", CartItemComponents);

class BundleDropdown extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector(".bundle-dropdown-toggle");
    this.bundleList = this.querySelector(".cart-item-bundle-list");

    if (this.toggleButton && this.bundleList) {
      this.toggleButton.addEventListener("click", () => this.toggleDropdown());
    }
  }

  toggleDropdown() {
    const isExpanded =
      this.toggleButton.getAttribute("aria-expanded") === "true";
    const itemCount = this.bundleList.querySelectorAll("li").length;

    if (isExpanded) {
      this.toggleButton.setAttribute("aria-expanded", "false");
      this.bundleList.hidden = true;
      this.toggleButton.innerHTML = `Show bundle items<svg class="icon-caret" width="8" height="8" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    } else {
      this.toggleButton.setAttribute("aria-expanded", "true");
      this.bundleList.hidden = false;
      this.toggleButton.innerHTML = `Hide bundle items<svg class="icon-caret" width="8" height="8" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    }
  }
}

customElements.define("bundle-dropdown", BundleDropdown);
